module.exports = "/_next/static/chunks/images/people-taking-notes-17ad4bff7df620b0dc11728ad9b2cdc4.jpg";